import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { BlueButton, NavButton } from 'components/Button'
import { PublishStatus } from 'types/message'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

type Props = {
  publishStatus: PublishStatus
}

const PushCompleteTemplate: FC<Props> = (props) => {
  const { publishStatus } = props
  const dispatch = useDispatch()

  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/notification.svg'} alt={''} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          {publishStatus === '0' && <>メッセージ配信の下書きが</>}
          {publishStatus === '1' && <>メッセージ配信の予約が</>}
          {publishStatus === '2' && <>メッセージ配信が</>}
          <br />
          完了しました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'配信履歴を確認する'}
        onClick={() => dispatch(push('/admin/push_notification/list'))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default PushCompleteTemplate
